/**
 * @generated SignedSource<<f951b3fc3f128f9e404d16873f1a947b>>
 * @relayHash ac9fe597c97e355b9b06125acdecd0e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ac90e6be0182ee4035fafa4efdbb1821e6dc1d553def9e4e168b7375a8fb329

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SchedulesPageQuery } from './SchedulesPageQuery.graphql';

const node: PreloadableConcreteRequest<SchedulesPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1ac90e6be0182ee4035fafa4efdbb1821e6dc1d553def9e4e168b7375a8fb329",
    "metadata": {},
    "name": "SchedulesPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
